export function spheres(): string {
  return 'spheres';
}
